import { useState, Fragment } from "react";
import { ProductFormType } from "../../ProductForm.types";
import { CiteoBlock } from "src/components/Partnership/CiteoBlock";
import { NoPackagings } from "./NoPackagings";
import { PackagingsModal } from "./PackagingsModal/PackagingsModal";
import { PackagingsFormGrid } from "./PackagingsFormGrid/PackagingsFormGrid";
import { useTheme } from "@mui/material";

type Page3Props = {
    product: ProductFormType;
    setProduct: (newProduct: ProductFormType) => void;
};

export const Page3 = (props: Page3Props) => {
    const { product, setProduct } = props;
    const [isOpen, setOpen] = useState(false);
    const openModal = () => setOpen(true);
    const theme = useTheme();

    return (
        <div
            style={{
                paddingTop: theme.spacing(4),
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
            }}
        >
            <PackagingsModal
                productPackagings={product.productPackagings}
                isOpen={isOpen}
                setOpen={setOpen}
                onValidate={(newPackagings) => {
                    setProduct({
                        ...product,
                        productPackagings: newPackagings,
                    });
                }}
            />
            {product.productPackagings.length > 0 ?
                <Fragment>
                    <PackagingsFormGrid
                        packagings={product.productPackagings}
                        productWeight={product.netWeight ?? 0}
                        openModal={openModal}
                        setProductPackagings={(newProductPackagings) => {
                            setProduct({
                                ...product,
                                productPackagings: newProductPackagings,
                            });
                        }}
                    />
                </Fragment>
            :   <NoPackagings openModal={openModal} />}
            <CiteoBlock />
        </div>
    );
};
